import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ButtonModule } from "@sitemule/ng-components/components/button";
import { SvgIconModule } from '@sitemule/ng-components/directives/svg-icon';
import { LinksComponent } from "./links.component";


@NgModule({
  declarations: [
    LinksComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    SvgIconModule,
    RouterModule,
  ],
  exports:[LinksComponent],
  providers: [],
  bootstrap: [],
})
export class LinksModule {}
